<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>STOK GÜNCELLEME EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">STOK GÜNCELLEME EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">STOK GÜNCELLEME EKRANI</h3>

            <div class="tile-body">
              <form>
                <div class="form-group">
                  <label class="control-label">Saha Adı</label>
                  <span
                    style="background-color: rgb(253, 109, 73);"
                    class="form-control"
                    >{{ veriler.sahaId }}</span
                  >
                </div>
                <div class="form-group">
                  <label class="control-label">Mevcut Makine Adı</label>
                  <span
                    style="background-color: rgb(253, 109, 73);"
                    class="form-control"
                    >{{ veriler.makina_id }}</span
                  >
                </div>
                <label class="control-label"
                  >Güncelleme Sonrası Makina Adı</label
                >
                <select
                  style="background-color: rgb(127, 238, 132);"
                  class="form-control"
                  @change="changemakina($event)"
                >
                  <option value="" selected disabled>MAKİNA SEÇİNİZ</option>
                  <option
                    v-for="machine in machines"
                    :value="machine.id"
                    :key="machine.id"
                    >{{
                      machine.makina_code + " " + machine.makina_name
                    }}</option
                  >
                </select>
                <div class="form-group">
                  <label class="control-label">Tarih Güncelleme</label>
                  <input
                    v-model="veriler.date"
                    class="form-control"
                    type="date"
                    placeholder="Delgi Çapı"
                    style="background-color: rgb(127, 238, 132);"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">Adet</label>
                  <input
                    v-model="veriler.adet"
                    class="form-control"
                    type="text"
                    placeholder="Stok Adeti"
                    style="background-color: rgb(127, 238, 132);"
                  />
                </div>
                <div class="form-group">
                  <label class="control-label">Mevcut Operatör Adı </label>
                  <span
                    class="form-control"
                    type="text"
                    placeholder="AÇIKLAMA GİRİNİZ"
                    style="background-color: rgb(253, 109, 73);"
                    >{{ veriler.personelname }}
                  </span>
                </div>
                <div class="form-group">
                  <label class="control-label"
                    >Güncelleme Sonrası Personel Adı</label
                  >
                  <select
                    style="background-color: rgb(127, 238, 132);"
                    class="form-control"
                    @change="changepersonel($event)"
                  >
                    <option value="" selected disabled>Personel Seçiniz</option>
                    <option
                      v-for="personel in personeller"
                      :value="personel.id"
                      :key="personel.id"
                      >{{ personel.name }} {{ personel.surname }}</option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label class="control-label">Açıklama</label>
                  <input
                    v-model="veriler.aciklama"
                    class="form-control"
                    type="text"
                    placeholder="AÇIKLAMA GİRİNİZ"
                    style="background-color: rgb(127, 238, 132);"
                  />
                </div>
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-success" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Güncelle
              </button>
              <button
                @click="deleteNote()"
                class="btn btn-danger fileupload-exists"
              >
                <i class="fa fa-trash-o"></i>Stok Sil
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";

export default {
  data() {
    return {
      machines: [],
      category: [],
      makinaId: "",
      tempmachine: "",
      temppersonel: "xx",
      personeller: [],
      sahaname: "",
      yonlendir: "",
      veriler: [],
      giderId: this.$route.query.id,
      sahaYonlendir: this.$route.query.sahaId,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getByIdStok.php?key=123";
    var datas = { stokId: this.giderId };
    axios
      .post(url, JSON.stringify(datas))
      .then((response) => {
        this.veriler = response.data[0];
        this.tempmachine = response.data[0].makine_id;
        this.temppersonel = response.data[0].personel_id;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url = store.state.base_url + "AslanSahalar/getAllMakina.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.machines = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url3 = store.state.base_url + "AslanSahalar/getAllPersonel.php?key=123";
    axios
      .post(url3)
      .then((response3) => {
        this.personeller = response3.data;
        //     console.log(response3.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    changemakina(event) {
      this.makinaId = event.target.value;
    },
    changepersonel(event) {
      this.temppersonel = event.target.value;
      console.log(this.temppersonel);
    },
    deleteNote: function() {
      var url = store.state.base_url + "AslanSahalar/deleteStok.php?key=123";

      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        raporId: this.giderId,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          console.log(response.data);
          if (response.data == true) {
            this.$swal({
              text: "Stok Başarıyla Silindi",
              icon: "success",
              closeOnClickOutside: false,
            });
          }
          //////////console.log(response);
        })
        .catch((error) => {
          //////console.log(error.response);
        });
    },
    reload: function() {
      location.reload();
    },
    sendData: function() {
      if (this.makinaId == 0) {
        var url = store.state.base_url + "AslanSahalar/updateStok.php?key=123";
        var datas = {
          makine_id: this.tempmachine,
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          date: this.veriler.date,
          delgiadeti: this.veriler.delgiadeti,
          adet: this.veriler.adet,
          aciklama: this.veriler.aciklama,
          giderId: this.giderId,
          personel_id: this.temppersonel,
          yonlendir: this.veriler.yonlendir,
        };
      } else {
        var url = store.state.base_url + "AslanSahalar/updateStok.php?key=123";
        var datas = {
          makine_id: this.makinaId,
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          date: this.veriler.date,
          delgiadeti: this.veriler.delgiadeti,
          adet: this.veriler.adet,
          aciklama: this.veriler.aciklama,
          giderId: this.giderId,
          personel_id: this.temppersonel,
          yonlendir: this.veriler.yonlendir,
        };
      }

      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.data == true) {
            this.$swal({
              text: "Güncelleme İşleminiz Başarıyla Gerçekleştirildi!",
              icon: "success",
              closeOnClickOutside: true,
            });
            setTimeout(function() {
              window.location =
                "studentsDetail?idm=" +
                response.data.yonlendir +
                "#/sahadetail?idm=" +
                response.data.yonlendir;
            }, 1250);
          } else {
            this.$swal({
              text: "Hata Oluştu Admine Danışın!",
              icon: "error",
              closeOnClickOutside: false,
            });
          }
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/StokGuncelleme.vue